const server = 'https://miapp.extremepaq.com'
// const server = 'http://mdev7.onecontrolcargosystem.com';
// const server = 'https://www.miapprp.onecontrolcargosystem.com';

const Api = {
  //   server: window.location.origin,
  login: server + '/manlogin.php',
  packs: server + '/listarpaqjson.php',
  office: server + '/misoficinajson.php',
  profile: server + '/misdatosjson.php',
  logout: server + '/logoff.php',
  uploadInvoice: server + '/mancargafactura.php',
  uploadInvoicePrealerta: server + '/mancargafacturaprealerta.php',
  prealertas: server + '/listarprealertajson.php',
  createPrealerta: server + '/manprealerta.php',
  createDeliveryRequest: server + '/mandomicilio.php',
  DeliveryRequest: server + '/listarpaqjsondomicilio.php',
  provincias: server + '/listprovinciasjson.php',
  oficinas: server + '/listoficinasjson.php',
  registro: server + '/manregistro.php',
  buscar: server + '/buscapaquetejson.php'



}
export default Api